import { useQuery } from 'react-query';
import { errorHandler } from 'App/utils';
import { getPatientRecordData } from './PatientRecordService';

function useFetchPatientRecordData(activeKey) {
    return useQuery(['patientRecordData', activeKey], () => getPatientRecordData(activeKey), {
        enabled: !!activeKey,
        onError: errorHandler,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchPatientRecordData;
